export const useAdvantageSorting = (advantages, showFirstLabel = true) => {
  const dictOrder = {
    RI: 1,
    OR: 2,
    ODR: 3,
    EC: 4,
    PF: 5
  };

  const advantageSorted = computed(() => {
    const table = [];

    const mardiPass = advantages.filter(
      (el) => el.prime_fid?.type === "PASS_DAY"
    );
    if (mardiPass.length > 0) {
      table.push({
        type: "PASS_DAY",
        advantages: mardiPass,
        label: null
      });
    }

    const primeBio = advantages.filter(
      (el) => el.prime_fid?.type === "CLUB_BIO"
    );
    if (primeBio.length > 0) {
      table.push({
        type: "PRIME_BIO",
        advantages: primeBio,
        label: null
      });
    }

    const primeMarche = advantages.filter(
      (el) => el.prime_fid?.type === "CLUB_MARCHE"
    );

    if (primeMarche.length > 0) {
      table.push({
        type: "PRIME_MARCHE",
        advantages: primeMarche,
        label: null
      });
    }

    const other = advantages.filter(
      (el) => el.type_avantage !== "EC" && el.type_avantage !== "PF"
    );
    if (other.length > 0) {
      table.push({
        type: "OTHER",
        advantages: other,
        label: null
      });
    }

    const avantagesFid = advantages.filter(
      (el) =>
        (el.type_avantage === "EC" || el.type_avantage === "PF") &&
        !el.prime_fid
    );
    if (avantagesFid.length > 0) {
      table.push({
        type: "FID",
        advantages: avantagesFid,
        label: null
      });
    }

    table.forEach((el) => {
      el.advantages = el.advantages.sort((a, b) => {
        return dictOrder[a.type_avantage] - dictOrder[b.type_avantage];
      });
    });

    table.forEach((el) => {
      el.label = el.advantages[0].texte_avantage;
    });

    return table;
  });

  const isFidelite = (type) => {
    return type === "FID";
  };

  const isPrimeBio = (typeAvantage) => {
    return typeAvantage === "PRIME_BIO";
  };

  const isPrimeMarche = (typeAvantage) => {
    return typeAvantage === "PRIME_MARCHE";
  };

  const isMardiPass = (typeAvantage) => {
    return typeAvantage === "PASS_DAY";
  };

  const isPrimeAdvantage = (typeAvantage) => {
    return isPrimeBio(typeAvantage) || isPrimeMarche(typeAvantage);
  };

  const getVariantFromAdvantage = (advType) => {
    if (isMardiPass(advType)) {
      return "carte-pass-carrefour";
    } else if (isPrimeAdvantage(advType)) {
      return "carte-club-carrefour";
    } else if (isFidelite(advType)) {
      return "fidelite";
    } else {
      return "advantage";
    }
  };

  const advantageStyle = (advantageType) => {
    return [
      isMardiPass(advantageType) &&
        "c-product-list-item-advantages__label--mardi-pass",
      isPrimeBio(advantageType) &&
        "c-product-list-item-advantages__label--prime-bio",
      isPrimeMarche(advantageType) &&
        "c-product-list-item-advantages__label--prime-marche",
      isFidelite(advantageType) &&
        "c-product-list-item-advantages__label--fidelite"
    ];
  };

  return {
    advantageSorted,
    isFidelite,
    isPrimeBio,
    isPrimeMarche,
    getVariantFromAdvantage,
    isPrimeAdvantage,
    advantageStyle,
    isMardiPass
  };
};
